import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MdKeyboardArrowRight } from "react-icons/md";
import img1 from "../../Assets/oakaylogo.png";
import { MdClass } from "react-icons/md";
import { BsFillSignIntersectionFill } from "react-icons/bs";
import { VscSymbolClass } from "react-icons/vsc";
import { RiParentFill } from "react-icons/ri";
import { FaPhoneVolume } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { FaTransgenderAlt } from "react-icons/fa";
import { MdBloodtype } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
import { MdWifiCalling3 } from "react-icons/md";
import { GoNumber } from "react-icons/go";
import { MdError } from "react-icons/md";
import img5 from "../../Assets/pending.png";
import Exam from "../../Assets/exam.png";
import { FaRegCalendarAlt } from "react-icons/fa";
import { PiExamFill } from "react-icons/pi";
import { PiExamDuotone } from "react-icons/pi";
import { FaBusAlt } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import SummaryApi from "../../common";
import StudentModal from "./StudentModal";
import { LiaBirthdayCakeSolid } from "react-icons/lia";
import { FaPrayingHands } from "react-icons/fa";
import { SiLinuxprofessionalinstitute } from "react-icons/si";
const getStudentImage = (imagePath) => {
  // Remove "images/" prefix if it exists, then create the full URL
  const imagePathWithoutPrefix = imagePath.startsWith("images/")
    ? imagePath.slice(7)
    : imagePath;
  return `${SummaryApi.getStudentImage.url}${imagePathWithoutPrefix}`;
};
const StudentDetails = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const location = useLocation();
  const student = location.state; // Get the passed student data

  if (!student) {
    return <div>No student data available</div>;
  }
  const handleSave = async (updatedStudent) => {
    try {
      console.log("Updated student data:", updatedStudent); // Check if student ID is included
  
      const response = await fetch(SummaryApi.updateStudent.url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedStudent),
      });
  
      const data = await response.json();
  
      if (response.ok && data.success) {
        console.log("Student updated successfully:", data);
      } else {
        console.error("Failed to update student:", data.message);
      }
    } catch (error) {
      console.error("Error updating student:", error);
    }
  };
  
  const handleModalClose = () => {
    setModalOpen(false);
  };
  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-3">Students</h1>

      <nav className="text-gray-600 mb-4">
        <ol className="flex space-x-2 text-[16px]">
          <li>
            <Link to="/dashboard" className="hover:text-[#ffa404]">
              Home
            </Link>
          </li>
          <li className="text-[#ffa404]">
            <MdKeyboardArrowRight size={25} />
          </li>
          <li className="text-[#ffa404]">
            <Link to="/allStudents" className="hover:text-[#ffa404]">
              Student Details
            </Link>
          </li>
        </ol>
      </nav>

      <div className="bg-white shadow-md rounded-lg p-6 mt-6 ">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">About Me</h2>

        <div className="grid grid-cols-4 gap-6 mb-5">
          <div className="bg-gradient-to-r from-red-300 via-red-400 to-red-600 p-4 rounded-lg shadow-md">
            <div className="flex row justify-between items-center">
              <h3 className="text-lg font-semibold mb-2 text-[#fff]">
                Attendance
              </h3>
              <FaRegCalendarAlt size={30} className="text-[#fff]" />
            </div>

            <div className="flex row justify-between items-center">
              <p className="text-md font-semibold mb-2 text-[#fff]">March</p>
              <p className="text-md  mb-2 text-[#fff]">2/31</p>
            </div>
          </div>
          <div className="bg-gradient-to-r from-blue-300 via-blue-400 to-blue-600 p-4 rounded-lg shadow-md">
            <div className="flex row justify-between items-center">
              <h3 className="text-lg font-semibold mb-2 text-[#fff]">Exams</h3>
              <PiExamFill size={38} className="text-[#fff]" />
            </div>
            <div className="flex row justify-between items-center">
              <p className="text-md font-semibold mb-2 text-[#fff]">
                Quarterly
              </p>
              <p className="text-md  mb-2 text-[#fff]">70%</p>
            </div>
          </div>
          <div className="bg-gradient-to-r from-green-300 via-green-400 to-green-600 p-4 rounded-lg shadow-md">
            <div className="flex row justify-between items-center">
              <h3 className="text-lg font-semibold mb-2 text-[#fff]">
                Daily Test
              </h3>
              <PiExamDuotone size={38} className="text-[#fff]" />
            </div>
            <div className="flex row justify-between items-center">
              <p className="text-md font-semibold mb-2 text-[#fff]">Test-38</p>
              <p className="text-md  mb-2 text-[#fff]">03-03-2025</p>
            </div>
          </div>
          <div className="bg-gradient-to-r from-yellow-300 via-yellow-400 to-yellow-600 p-4 rounded-lg shadow-md">
            <h3 className="text-lg font-semibold mb-2"></h3>
            <div className="flex row justify-between items-center">
              <h3 className="text-lg font-semibold mb-2 text-[#fff]">
                Transport
              </h3>
              <FaBusAlt size={35} className="text-[#fff]" />
            </div>
            <div className="flex row justify-between items-center">
              <p className="text-md font-semibold mb-2 text-[#fff]">
                Route-VIJ
              </p>
              <p className="text-md  mb-2 text-[#fff]">2076</p>
            </div>
          </div>
        </div>

        <div className="flex space-x-6">
          {/* Left Section - 75% width */}
          <div className="w-3/4 bg-[#FFF] rounded-lg">
            <div className="p-4 rounded-lg shadow-md  mb-6">
              <h3 className="text-lg font-semibold mb-2">Student Details</h3>

              <div className="flex items-center justify-between mb-2">
                <img
                  src={getStudentImage(student.student_image)}
                  alt={student.student_name}
                  className="w-24 h-24 rounded-full mb-4 border border-solid border-gray-300"
                />
                <button
                  className="bg-blue-500 text-white font-bold p-2 rounded-md hover:bg-blue-600 transition"
                  onClick={() => setModalOpen(true)}
                >
                  Edit Profile
                </button>
              </div>

              <strong className="text-xl">
                {student.first_name} {student.last_name} ({student.student_code}
                )
              </strong>
              {/* <p>
                Attendance: <span className="text-green-500">Present</span>
              </p> */}

              <div className="mt-3 ml-[5%]">
                {/* Father's Name */}
                <div className="flex items-center mb-2">
                  <RiParentFill className="mr-2 text-gray-700" />
                  <p className="flex w-full">
                    <span className="w-[30%] text-left">Father's Name</span>
                    <span className="w-[10%] text-center">:</span>
                    <span className="w-[60%] text-left">
                      {student.father_name}
                    </span>
                  </p>
                </div>

                {/* Mother's Name */}
                <div className="flex items-center mb-2">
                  <RiParentFill className="mr-2 text-gray-700" />
                  <p className="flex w-full">
                    <span className="w-[30%] text-left">Mother's Name</span>
                    <span className="w-[10%] text-center">:</span>
                    <span className="w-[60%] text-left">
                      {student.mother_name}
                    </span>
                  </p>
                </div>

                {/* Mobile Number */}
                <div className="flex items-center mb-2">
                  <FaPhoneVolume className="mr-2 text-gray-700" />
                  <p className="flex w-full">
                    <span className="w-[30%] text-left">Mobile Number</span>
                    <span className="w-[10%] text-center">:</span>
                    <span className="w-[60%] text-left">
                      {student.mobile_number}
                    </span>
                  </p>
                </div>

                {/* Parent Number */}
                <div className="flex items-center mb-2">
                  <MdWifiCalling3 className="mr-2 text-gray-700" />
                  <p className="flex w-full">
                    <span className="w-[30%] text-left">Parent Number</span>
                    <span className="w-[10%] text-center">:</span>
                    <span className="w-[60%] text-left">
                      {student.parent_mobile_number}
                    </span>
                  </p>
                </div>
                {/* DOB */}
                <div className="flex items-center mb-2">
                  <LiaBirthdayCakeSolid className="mr-2 text-gray-700" />
                  <p className="flex w-full">
                    <span className="w-[30%] text-left">Date of Birth</span>
                    <span className="w-[10%] text-center">:</span>
                    <span className="w-[60%] text-left">{student.dob}</span>
                  </p>
                </div>
                {/* Religion */}
                <div className="flex items-center mb-2">
                  <FaPrayingHands className="mr-2 text-gray-700" />
                  <p className="flex w-full">
                    <span className="w-[30%] text-left">Religion</span>
                    <span className="w-[10%] text-center">:</span>
                    <span className="w-[60%] text-left">
                      {student.religion}
                    </span>
                  </p>
                </div>
                {/* Father's Occupation */}
                <div className="flex items-center mb-2">
                  <MdEmail className="mr-2 text-gray-700" />
                  <p className="flex w-full">
                    <span className="w-[30%] text-left">
                      Father's Occupation
                    </span>
                    <span className="w-[10%] text-center">:</span>
                    <span className="w-[60%] text-left">
                      {student.father_occupation}
                    </span>
                  </p>
                </div>
                {/* Email */}
                <div className="flex items-center mb-2">
                  <MdEmail className="mr-2 text-gray-700" />
                  <p className="flex w-full">
                    <span className="w-[30%] text-left">Email</span>
                    <span className="w-[10%] text-center">:</span>
                    <span className="w-[60%] text-left">{student.email}</span>
                  </p>
                </div>

                {/* Gender */}
                <div className="flex items-center mb-2">
                  <FaTransgenderAlt className="mr-2 text-gray-700" />
                  <p className="flex w-full">
                    <span className="w-[30%] text-left">Gender</span>
                    <span className="w-[10%] text-center">:</span>
                    <span className="w-[60%] text-left">{student.gender}</span>
                  </p>
                </div>

                {/* Blood Group */}
                <div className="flex items-center mb-2">
                  <MdBloodtype className="mr-2 text-gray-700" />
                  <p className="flex w-full">
                    <span className="w-[30%] text-left">Blood Group</span>
                    <span className="w-[10%] text-center">:</span>
                    <span className="w-[60%] text-left">
                      {student.blood_group}
                    </span>
                  </p>
                </div>

                {/* Address */}
                <div className="flex items-center mb-2">
                  <FaLocationDot className="mr-2 text-gray-700" />
                  <p className="flex w-full">
                    <span className="w-[30%] text-left">Address</span>
                    <span className="w-[10%] text-center">:</span>
                    <span className="w-[60%] text-left">
                      {student.address}
                      {student.city},{student.state},{student.pincode}
                    </span>
                  </p>
                </div>
                <div className="flex items-center mb-2">
                  <FaLocationDot className="mr-2 text-gray-700" />
                  <p className="flex w-full">
                    <span className="w-[30%] text-left">Nationality</span>
                    <span className="w-[10%] text-center">:</span>
                    <span className="w-[60%] text-left">
                      {student.nationality}
                    </span>
                  </p>
                </div>
                {/* Aadhar Number */}
                <div className="flex items-center mb-2">
                  <GoNumber className="mr-2 text-gray-700" />
                  <p className="flex w-full">
                    <span className="w-[30%] text-left">Aadhar Number</span>
                    <span className="w-[10%] text-center">:</span>
                    <span className="w-[60%] text-left">
                      {" "}
                      {student.aadhar_number}
                    </span>
                  </p>
                </div>
                {/* Password */}
                <div className="flex items-center mb-2">
                  <FaEye className="mr-2 text-gray-700" />
                  <p className="flex w-full">
                    <span className="w-[30%] text-left">Password</span>
                    <span className="w-[10%] text-center">:</span>
                    <span className="w-[60%] text-left">
                      {" "}
                      {student.password}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Section - 25% width */}
          <div className="w-1/4 rounded-lg">
            <div className="p-4 rounded-lg shadow-md mb-6">
              <div className="text-center mb-4">
                <p>
                  <strong>Your Pending Amount:</strong>
                </p>
                <p>₹300</p>
                <div className="flex justify-center items-center">
                  <img src={img5} className="w-[18%]" />
                  {/* <MdError className="text-red-500 text-5xl" /> */}
                </div>
              </div>

              <h3 className="text-lg font-semibold mb-4">Fee Details</h3>
              <div className="flex justify-between mb-2">
                <p>Books Fee:</p>
                <p>₹100</p>
              </div>

              <div className="flex justify-between mb-2">
                <p>College Fee:</p>
                <p>₹1000</p>
              </div>

              <div className="flex justify-between mb-2">
                <p>Tuition Fee:</p>
                <p>₹500</p>
              </div>

              <div className="flex justify-between mb-2">
                <p>Uniform:</p>
                <p>₹200</p>
              </div>

              <div className="flex justify-between mb-2">
                <p>Bus Fee:</p>
                <p>₹100</p>
              </div>

              <div className="flex justify-between mb-2">
                <p>ID Card Amount:</p>
                <p>₹50</p>
              </div>

              <div className="flex justify-between mb-2">
                <p>Paid Amount:</p>
                <p>₹700</p>
              </div>

              <div className="flex justify-between mb-2">
                <p>Pending Amount:</p>
                <p>₹500</p>
              </div>

              <div className="flex justify-between mb-4">
                <p>
                  <strong>Total Amount:</strong>
                </p>
                <p>
                  <strong>₹1200</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Modal for editing profile */}
        <StudentModal
          student={student}
          isOpen={isModalOpen}
          closeModal={handleModalClose}
          onSave={handleSave}
        />
        <div className="mt-6">
          <h3 className="text-lg font-semibold mb-4">Student Timetable</h3>
          <table className="min-w-full table-auto border-collapse border border-gray-300">
            <thead>
              <tr>
                <th className="border p-2 text-left">Time</th>
                <th className="border p-2 text-left">10:00-10:45</th>
                <th className="border p-2 text-left">10:45-11:30</th>
                <th className="border p-2 text-left">11:30-12:15</th>
                <th className="border p-2 text-left">12:15-01:00</th>
                <th className="border p-2 text-left">Lunch Break</th>
                <th className="border p-2 text-left">01:45-02:15</th>
                <th className="border p-2 text-left">02:15-03:00</th>
                <th className="border p-2 text-left">03:00-03:45</th>
                <th className="border p-2 text-left">03:45-04:30</th>
              </tr>
            </thead>
            <tbody>
              {/* Sample data for timetable with 45-min intervals */}
              <tr>
                <td className="border p-2">MON</td>
                <td className="border p-2">English</td>
                <td className="border p-2">Mathematics</td>
                <td className="border p-2">History</td>
                <td className="border p-2">Science</td>
                <td className="border p-2"></td>
                <td className="border p-2">Geography</td>
                <td className="border p-2">Physical Education</td>
                <td className="border p-2">Chemistry</td>
                <td className="border p-2">Sports</td>
              </tr>
              <tr>
                <td className="border p-2">TUE</td>
                <td className="border p-2">English</td>
                <td className="border p-2">Mathematics</td>
                <td className="border p-2">History</td>
                <td className="border p-2">Science</td>
                <td className="border p-2"></td>
                <td className="border p-2">Geography</td>
                <td className="border p-2">Physical Education</td>
                <td className="border p-2">Chemistry</td>
                <td className="border p-2">Sports</td>
              </tr>
              <tr>
                <td className="border p-2">WED</td>
                <td className="border p-2">Science</td>
                <td className="border p-2">History</td>
                <td className="border p-2">Mathematics</td>
                <td className="border p-2">Geography</td>
                <td className="border p-2"></td>
                <td className="border p-2">Biology</td>
                <td className="border p-2">English</td>
                <td className="border p-2">Chemistry</td>
                <td className="border p-2">Sports</td>
              </tr>
              <tr>
                <td className="border p-2">THUR</td>
                <td className="border p-2">History</td>
                <td className="border p-2">Science</td>
                <td className="border p-2">English</td>
                <td className="border p-2">Mathematics</td>
                <td className="border p-2"></td>
                <td className="border p-2">Chemistry</td>
                <td className="border p-2">Physical Education</td>
                <td className="border p-2">Chemistry</td>
                <td className="border p-2">Sports</td>
              </tr>
              <tr>
                <td className="border p-2">FRi</td>
                <td className="border p-2">History</td>
                <td className="border p-2">Science</td>
                <td className="border p-2">English</td>
                <td className="border p-2">Mathematics</td>
                <td className="border p-2"></td>
                <td className="border p-2">Chemistry</td>
                <td className="border p-2">Physical Education</td>
                <td className="border p-2">Chemistry</td>
                <td className="border p-2">Sports</td>
              </tr>
              <tr>
                <td className="border p-2">SAT</td>
                <td className="border p-2">History</td>
                <td className="border p-2">Science</td>
                <td className="border p-2">English</td>
                <td className="border p-2">Mathematics</td>
                <td className="border p-2"></td>
                <td className="border p-2">Chemistry</td>
                <td className="border p-2">Physical Education</td>
                <td className="border p-2">Chemistry</td>
                <td className="border p-2">Sports</td>
              </tr>
              {/* Continue for more time slots */}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default StudentDetails;
